import {
  MenuRoot,
  MenuContent,
  MenuItem,
  useSidebarContext,
  ButtonIcon,
  MenuTrigger,
  Show,
} from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import {
  useJournalDeleteNoteMutation,
  useJournalMarkNoteAsUnreadMutation,
  useJournalMarkNoteAsReadMutation,
} from 'features/journal/hooks';
import { openJournalSidebar } from 'features/journal/utils';

type TJournalCardMenu = {
  isAuthor: boolean;
  onEdit: () => void;
  noteId: string;
  isNoteRead: boolean;
};

export const JournalCardMenu = ({
  isAuthor,
  onEdit,
  noteId,
  isNoteRead,
}: TJournalCardMenu) => {
  const { participantEmail, participantId } = useSidebarContext();

  const { mutateAsync: markNotesAsUnread } = useJournalMarkNoteAsUnreadMutation(
    { noteId, participantId }
  );
  const { mutateAsync: markNotesAsRead } = useJournalMarkNoteAsReadMutation({
    noteId,
    participantId,
  });

  const { mutateAsync: deleteNote } = useJournalDeleteNoteMutation({
    noteId,
    participantId,
  });

  const { location, user, filters } = useSidebarContext();

  const handleNoteReadStatus = async () => {
    const toggleNoteReadStatus = isNoteRead
      ? markNotesAsUnread
      : markNotesAsRead;
    await toggleNoteReadStatus();
  };

  const handleDeleteNote = async () => {
    await deleteNote();

    location === 'replies' &&
      openJournalSidebar({
        user,
        participantEmail,
        filters,
        participantId,
      });
  };

  return (
    <MenuRoot>
      <MenuTrigger asChild>
        <ButtonIcon
          aria-label="Options"
          variant="ghost"
          size="sm"
          data-testid="journal-sidebar-card-menu-options"
        >
          <Icon name={iconNames.ellipsisHorizontal} />
        </ButtonIcon>
      </MenuTrigger>
      <MenuContent portalled={false}>
        <Show
          when={isAuthor}
          fallback={
            <MenuItem
              textStyle="xs"
              onClick={handleNoteReadStatus}
              data-testid="journal-sidebar-card-status"
            >
              Mark as {isNoteRead ? 'unread' : 'read'}
            </MenuItem>
          }
        >
          {() => (
            <>
              <MenuItem textStyle="xs" onClick={onEdit}>
                Edit
              </MenuItem>
              <MenuItem textStyle="xs" color="red" onClick={handleDeleteNote}>
                Delete
              </MenuItem>
            </>
          )}
        </Show>
      </MenuContent>
    </MenuRoot>
  );
};
